import { useDispatch } from "react-redux";
import { useGetNewChatsMutation } from "../../../Store/Builder/messaging.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import {appendChatsNew, setNewChatsUpdated, setNewChatsInfo} from "../../../Store/Slice/messagingSlice";
import showToast from "../../Hooks/toast";

const useGetNewChatsApi = () => {
  const dispatch = useDispatch();
  const [getNewChats] = useGetNewChatsMutation();

  const get = (data) => {
    dispatch(setLoader(true));
    getNewChats(data)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setNewChatsInfo(res));
        if(res.page <= 1) {
          dispatch(setNewChatsUpdated(res.data));
        } else {
          dispatch(appendChatsNew(res.data));
        }
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };

  return {
    get,
  };
};

export default useGetNewChatsApi;
